<template>
    <a class="nav-link" href="/notifications">
        <i class="bi bi-bell-fill"></i>
        <span class="badge-notification badge badge-primary bg-primary" v-show="state.counter.value > 0">
            {{ state.display.value }}
        </span>
    </a>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { userNotificationCounterState } from './useCounter';

export default defineComponent({
    name: 'NotificationsCounterMain',
    components: {},
    setup() {

        const state = userNotificationCounterState();

        return {
            state
        };
    }
});
</script>

<style scoped>
.badge-notification {
    min-width: 24px;
    font-family: monospace;
    transform: translate(0rem, -.25rem);
}
</style>